import SectionTitle from './title';
import Section from './container';

export {
  SectionTitle,
  Section,
};


// WEBPACK FOOTER //
// ./src/components/ui/Section/index.jsx